<template>
    <div :style="styleVar">
        <el-upload
            class="avatar-uploader"
            action=""
            :http-request="upload"
            :show-file-list="false">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div v-if="childMsg.tip" class="el-upload-tip" slot="tip">{{childMsg.tip}}</div>
        </el-upload>
    </div>
</template>
<script>
import axios from 'axios'
import OSS from 'ali-oss'
import { getOssToken } from '@/api/upload'
export default {
    name: 'singleUpload',
    props: ['childMsg'],
    data() {
        return {
            imageUrl: this.childMsg.imageUrl,
            client: null,
            domain: ''
        }
    },
    computed: {
        styleVar() {
            return {
                '--width': this.childMsg.width + 'px',
                '--height': this.childMsg.height + 'px'
            }
        }
    },
    created() {
        this.getOssToken()
    },
    methods: {
        getOssToken() {
            getOssToken().then(res => {
                if (res.code === 0) {
                    this.client = new OSS({
                        region: res.data.regionId,
                        accessKeyId: res.data.AccessKeyId,
                        accessKeySecret: res.data.AccessKeySecret,
                        stsToken: res.data.SecurityToken,
                        bucket: res.data.bucket
                    })
                    this.domain = res.data.domain
                }
            })
        },
        async putObject(data) {
            try {
                const point = data.name.lastIndexOf('.')
                let fileName = data.name.substr(0, point)
                let fileType = data.name.substr(point + 1, data.name.length)
                let timestamp = Date.parse(new Date())
                let name = fileName + '_' + timestamp + '.' + fileType
                return await this.client.put('assets/images/' + name, data)
            } catch (e) {
                console.log(e)
            }
        },
        upload(option) {
            this.putObject(option.file).then(res => {
                this.imageUrl = res.url
                this.$emit('imageUrl', this.domain + res.name)
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.avatar-uploader {
    ::v-deep.el-upload{
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        vertical-align: top;
        background-color: #FBFDFF;
        &:hover{
            border-color: #409EFF;
        }
    }
    .el-upload-tip{
        line-height: 20px;
        font-size: 12px;
        color: #909399;
    }
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: var(--width);
    height: var(--height);
    line-height: var(--height);
    text-align: center;
}
.avatar {
    width: var(--width);
    height: var(--height);
    display: block;
}
</style>
